import Image from "next/image";
import Link from "next/link";
import { displayFont, SoftFallback } from "@/components/content-blocks/band-helpers";
import { resolveMediaAlt } from "@/lib/product-display";
import type { CategorySummary } from "@/lib/storefront-types";

type CategoryCardProps = {
  category: CategorySummary;
};

export function CategoryCard({ category }: CategoryCardProps) {
  const href = `/menu/${category.slug}`;
  const imageAlt = resolveMediaAlt(category.image?.alt, category.name);

  return (
    <Link
      href={href}
      className="storefront-page-card storefront-page-card-interactive group block overflow-hidden rounded-2xl focus-visible:outline-none storefront-focus-ring"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-white p-3">
        {category.image ? (
          <Image
            src={category.image.url}
            alt={imageAlt}
            fill
            sizes="(min-width: 1024px) 22rem, (min-width: 640px) 50vw, 100vw"
            className="object-contain p-2"
          />
        ) : (
          <SoftFallback label="Category photo" />
        )}
        <div className="pointer-events-none absolute inset-x-0 top-0 z-[2] h-1 storefront-bg-primary opacity-0 transition-opacity duration-150 group-hover:opacity-100" />
      </div>

      <div className="border-t storefront-border-soft px-4 py-3.5 text-center transition-colors duration-150 group-hover-storefront-border-primary group-hover-storefront-bg-primary">
        <h2
          className={`${displayFont.className} text-[1.3rem] font-semibold leading-tight tracking-[0.01em] storefront-text-heading transition-colors duration-150 group-hover-text-white`}
        >
          {category.name}
        </h2>
      </div>
    </Link>
  );
}
